import { render, staticRenderFns } from "./APagination.vue?vue&type=template&id=2842258e&"
import script from "./APagination.vue?vue&type=script&lang=js&"
export * from "./APagination.vue?vue&type=script&lang=js&"
import style0 from "./APagination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports